import React from 'react';
import { CartItemThankYouPage } from './CartItemThankyouPage';
import { OrderAndUpSellSummary } from '../../interface/commonInterface';
import { IOrdersProductDetails } from './OrderSummary';
import { getMarginStyles, getPaddingStyles } from '../../utils/helper';
import { MarginType } from '../../puck/reusable-props/margin';

interface IProps {
  value: OrderAndUpSellSummary | null;
  productDetails: IOrdersProductDetails;
  width: number;
  currentDeviceType?: keyof MarginType;
  className?: string;
  hideProductThankYou?: string;
}
const CartDetails = ({
  value,
  productDetails,
  width,
  currentDeviceType,
  className = '',
  hideProductThankYou,
}: IProps) => {
  if (!value) return null;
  const marginStyles = getMarginStyles(
    productDetails.margin,
    currentDeviceType ?? 'desktop',
  );
  return (
    <div
      style={{
        ...marginStyles,
        ...getPaddingStyles(
          productDetails?.padding,
          currentDeviceType ?? 'desktop',
        ),
      }}
      className={`space-y-6  text-sm font-medium text-gray-900 lg:block ${className}`}>
      {value?.products?.length > 0 ? (
        <>
          <ul role="list" className={`divide-y divide-gray-200 `}>
            <div className={`relative w-full 'opacity-100'}`}>
              {value?.products?.map(
                line =>
                  hideProductThankYou !==
                    `gid://shopify/ProductVariant/${line?.variantId}` && (
                    <CartItemThankYouPage
                      key={line?.productName}
                      product={line}
                      symbol={
                        value?.currencySymbol ? value?.currencySymbol : '$'
                      }
                      productDetailsData={productDetails}
                      width={width}
                    />
                  ),
              )}
            </div>
          </ul>
        </>
      ) : null}
    </div>
  );
};

export default CartDetails;
